/*
common/lib/utils/constants

usage:

Naming-convention: MODULENAME_EXTENSION

*/

const constants = {
	BONUSES: 'bonuses',
	DEFAULT: 'default',
	FEE: 'fee',
	FETCH_AMOUNTS: 'fetch_amounts',
	FETCH_BONUSES: 'fetch_bonuses',
	FETCH_BONUSES_FREE_MONEY_BONUS_SUCCESS: 'fetch_bonuses_free_money_bonus_success',
	FETCH_BONUSES_FOR_SHOP_DEPOSIT: 'fetch_bonuses_for_shop_deposit',
	FETCH_CANCEL_WITHDRAW: 'fetch_cancel_withdraw',
	FETCH_PENDING_WITHDRAWALS: 'fetch_pending_withdrawals',
	FETCH_FEES_AND_LIMITS: 'fetch_fees_and_limits',
	VALIDATE_FEES_AND_LIMITS_AT_SUBMIT: 'validate_fees_and_limits_at_submit',
	FETCH_PAYMENTMETHODS: 'fetch_paymentmethods',
	FETCH_METHODDETAILS: 'fetch_methoddetails',
	FETCH_TYPE_ASYNCH: 'fetch_type_asynch',
	FETCH_TYPE_SYNCH: 'fetch_type_synch',
	HANDLE_PAYMENT_RESPONSE: 'handle_payment_response',
	PAYMENT_HANDLED: 'payment_handled',
	PAYMENTMETHODS: 'paymentmethods',
	PENDING_WITHDRAWALS: 'pending_withdrawals',
	SETUP_BONUS: 'setup_bonus',
	SETUP_PAYMENT: 'setup_payment',
	SETUP_PENDING_WITHDRAWALS: 'setup_pending_withdrawals',
	SUBMIT_PAYMENT: 'submit_payment',
	TEST_PURPOSE: 'test_purpose',
	VIEW: 'view',
	VIEW_AMOUNTINPUT: 'view_amount_input',
	VIEW_AMOUNTSELECT: 'view_amountselect',
	VIEW_BONUS: 'view_bonus',
	VIEW_BONUS_FROM_SHOP: 'view_bonus_from_shop',
	VIEW_CURRENCYSELECT: 'view_currencyselect',
	VIEW_PENDING_WITHDRAWALS_NEXT: 'view_pending_withdrawals_next',
	VIEW_CREDITCARD: 'view_creditcard',
	VIEW_CREDITCARDLAST: 'view_creditcardlast',
	VIEW_CREDITCARDNEW: 'view_creditcardnew',
	VIEW_NAV: 'view_nav',
	VIEW_PAYMENTFORM: 'view_paymentform',
	VIEW_PAYMENTFORM_SUBMIT: 'view_paymentform_submit',
	VIEW_PAYMENT_METHOD_LINK: 'view_payment_method_link',
	VIEW_PENDING_WITHDRAWALS: 'view_pending_withdrawals',
	// payment Sendhandlers, defined as upper case in database
	RESULT_AFTER_SINGLE_CALL: 'RESULT_AFTER_SINGLE_CALL',
	PENDING_RESULT_AFTER_SINGLE_CALL: 'PENDING_RESULT_AFTER_SINGLE_CALL',
	EXTERNAL_PANEL: 'EXTERNAL_PANEL',
	EXTERNAL_WINDOW: 'EXTERNAL_WINDOW',
	SEND_HANDLER_CONTROLLER: 'SEND_HANDLER_CONTROLLER',
	INTERNAL_PANEL: 'INTERNAL_PANEL',
	ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL: 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL',
	EXTERNAL_WINDOW_IFRAME: 'EXTERNAL_WINDOW_IFRAME',
	// End payment sendhandlers
	// Payment status, defined as enum in java: successful, cancelled, pending, notFound
	SUCCESS: 'successful',
	CANCELLED: 'cancelled',
	PENDING: 'pending',
	NOT_FOUND: 'notFound',
	ERROR: 'error',
	FAIL: 'fail',
	RELOAD_BONUSES: 'reload_bonuses',
	SHOP_HANDLE_BONUS_FOR_DEPOSIT: 'shop_handle_bonus_for_deposit',
	VIEW_METHODS: 'VIEW_METHODS',
	// End Payment status
	TRANSITION_DEFAULT_TIME: 250,
	CANCEL_WITHDRAW_FAIL_NOTIFICATION: 'cancel_withdraw_fail_notification',
	RELOAD_BONUSES_FREE_MONEY_BONUS_SUCCESS: 'reload_bonuses_free_money_bonus_success',
	VIEW_SELECT_SKRILL_ACCOUNTING: 'view_selectskrillaccount',
	VIEW_SELECT_NETELLER_ACCOUNTING: 'view_selectnetelleraccount',
	DEPOSIT: 'deposit',
	WITHDRAW: 'withdraw'
};
const { FETCH_TYPE_SYNCH, FETCH_TYPE_ASYNCH } = constants;
// TODO: select the constants of importance and export them directly (previous line)
// to make it easier to spot which of them that are in use
export const { TRANSITION_DEFAULT_TIME } = constants;
export { FETCH_TYPE_SYNCH, FETCH_TYPE_ASYNCH };
export const limitsConst = {
	DEFAULT: 0,
	DEPOSIT: 1,
	WAGER: 2,
	SPEND: 3,
	TIME: 4,
	ACCUMULATED_LOSS: 5,
	LOSS: 6,
	SOW_AML_SPENDING_DEPOSIT_LIMIT: 7,
	BALANCE_LIMIT: 8
};

const rgLimitTypeToMessage = {
	[limitsConst.DEPOSIT]: 'MOBILE_DEPOSIT_LIMIT_REACHED',
	[limitsConst.BALANCE_LIMIT]: 'MOBILE_BALANCE_LIMIT_REACHED',
	[limitsConst.SPEND]: 'MOBILE_SPEND_LIMIT_REACHED'
};

export const getRGMessage = type => rgLimitTypeToMessage[limitsConst[type]];

export default constants;
